class Accordion extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    /**
     * @type {string | null}
     */
    this.openedItem = null
    /**
     * @type Element[]
     */
    this.items = []
  }

  closeItem(element) {
    const content = element.querySelector('[data-accordion-item-content]')
    content.style.height = '0'
    content.setAttribute('aria-hidden', 'true')
    content.inert = true // disables focusable elements inside
    const trigger = element.querySelector('[data-accordion-item-trigger]')
    trigger.setAttribute('aria-expanded', 'false')
    const arrow = trigger.querySelector('svg')
    if (arrow) {
      arrow.style.transition = 'transform 0.3s ease'
      arrow.style.transform = 'rotate(0deg)'
    }
  }

  openItem(element) {
    const content = element.querySelector('[data-accordion-item-content]')
    content.style.height = content.scrollHeight + 'px'
    content.setAttribute('aria-hidden', 'false')
    content.inert = false // makes content focusable when visible
    const trigger = element.querySelector('[data-accordion-item-trigger]')
    trigger.setAttribute('aria-expanded', 'true')
    const arrow = trigger.querySelector('svg')
    if (arrow) {
      arrow.style.transition = 'transform 0.3s ease'
      arrow.style.transform = 'rotate(180deg)'
    }
    this.openedItem = element.dataset.accordionItem
  }

  closeAllItems() {
    if (!this.openedItem) return
    const openElements = this.items.filter(item => item.dataset.accordionItem === this.openedItem)
    if (!openElements.length) return
    openElements.forEach(element => {
      this.closeItem(element)
    })
  }

  connectedCallback() {
    const slot = document.createElement('slot')
    slot.setAttribute('name', 'content')
    this.shadowRoot.append(slot)

    // Get the content assigned to the slot
    const content = slot.assignedNodes()?.[0]

    if (!content) {
      console.error('Accordion content slot not provided.')
      return
    }

    this.items = Array.from(content.querySelectorAll('[data-accordion-item]'))

    this.items.forEach(element => {
      /**
       * @type {string}
       */
      const value = element.dataset.accordionItem
      const contentElement = element.querySelector('[data-accordion-item-content]')
      contentElement.style.height = '0'
      contentElement.style.overflowY = 'clip'
      contentElement.style.transition = 'height 0.3s ease'
      contentElement.setAttribute('aria-hidden', 'true')
      contentElement.inert = true // make hidden content non-focusable
      // set role and id for the content panel
      contentElement.setAttribute('role', 'region')
      contentElement.id = 'accordion-panel-' + value.toLowerCase()

      const trigger = element.querySelector('[data-accordion-item-trigger]')
      trigger.setAttribute('aria-expanded', 'false')
      // ensure trigger has an id
      if (!trigger.id) {
        trigger.id = 'accordion-trigger-' + value.toLowerCase()
      }
      // link trigger to its panel
      trigger.setAttribute('aria-controls', contentElement.id)

      trigger.addEventListener('click', () => {
        if (this.openedItem === value) {
          this.closeItem(element)
          this.openedItem = null
        } else {
          this.closeAllItems()
          this.openItem(element)
        }
      })
    })
  }
}

if (!customElements.get('basis-accordion')) {
  customElements.define('basis-accordion', Accordion)
}
